import GptAd, { GptAdProps } from "./GptAd";

const NativeAd = (props: GptAdProps) => {
  return <GptAd format="native" sizesAt0="native" {...props} />;
};

export default NativeAd;
